// Analytics has been removed. Keep existing UI callbacks safe without tracking.
const trackCustomEventTrigger = () => undefined

export default trackCustomEventTrigger
